import { render, staticRenderFns } from "./DefinirSenha.vue?vue&type=template&id=f6bc3c18"
import script from "./DefinirSenha.vue?vue&type=script&lang=js"
export * from "./DefinirSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports